const LocalStorageService = (() => {
    let _service;
    const _getService = () => {
        if (!_service) {
            _service = this;
            return _service;
        }
        return _service;
    };

    const _setToken = (tokenObj) => {
        localStorage.setItem("jwtToken", tokenObj.token);
        localStorage.setItem("refreshToken", tokenObj.refreshToken);
    };

    const _setVersion = (version) => {
        localStorage.setItem("version", version);
    };

    const _getAccessToken = () => localStorage.getItem("jwtToken");

    const _getRefreshToken = () =>  localStorage.getItem("refreshToken");

    const _getVersion = () => localStorage.getItem("version");

    const _clearToken = () => {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("refreshToken");
    };

    return {
        getService: _getService,
        setToken: _setToken,
        setVersion: _setVersion,
        getAccessToken: _getAccessToken,
        getRefreshToken: _getRefreshToken,
        getVersion: _getVersion,
        clearToken: _clearToken
    };
})();

export default LocalStorageService;
